import { motion } from "framer-motion";
import { ArrowRight, Shield, TrendingUp } from "lucide-react";
import {useNavigate} from "react-router-dom";

export default function CTA() {
  const navigate = useNavigate(); 
  return (
    <section className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Ready to Transform Your Career?
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Join thousands of successful agents who have already taken the leap with TripSecure
          </p>
          
          <div className="flex flex-col gap-4 mt-8 sm:flex-row sm:justify-center">
            <button onClick={()=>navigate("/signin")} className="inline-flex justify-center items-center px-8 py-3 font-semibold text-white bg-emerald-600 rounded-full transition-all duration-300 hover:bg-emerald-700 hover:scale-105">
              Start Your Journey
              <ArrowRight size={20} className="ml-2" />
            </button>
            {/* <button className="inline-flex justify-center items-center px-8 py-3 font-semibold text-gray-700 rounded-full border-2 border-gray-300 transition-all duration-300 hover:border-emerald-500 hover:text-emerald-600 hover:scale-105">
              Learn More
            </button> */}
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 gap-6 mt-12 sm:grid-cols-3">
            <div className="flex flex-col items-center space-y-2">
              <div className="flex justify-center items-center w-12 h-12 bg-emerald-100 rounded-full">
                <Shield size={24} className="text-emerald-600" />
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-gray-900">10,000+</div>
                <div className="text-sm text-gray-600">Active Agents</div>
              </div>
            </div>
            
            <div className="flex flex-col items-center space-y-2">
              <div className="flex justify-center items-center w-12 h-12 bg-blue-100 rounded-full">
                <TrendingUp size={24} className="text-blue-600" />
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-gray-900">₵50K+</div>
                <div className="text-sm text-gray-600">Avg. Monthly Earnings</div>
              </div>
            </div>
            
            <div className="flex flex-col items-center space-y-2">
              <div className="flex justify-center items-center w-12 h-12 bg-purple-100 rounded-full">
                <Shield size={24} className="text-purple-600" />
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-gray-900">95%</div>
                <div className="text-sm text-gray-600">Success Rate</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
